import { useTranslation } from "react-i18next";

import { Tabs, TabsList, TabsTrigger } from "~/components/ui";
import { CATEGORY_TABS, type CategoryTab } from "~/features/admin/categories/hooks/useCategoryTab";

interface CategoriesTabsProps {
  active: CategoryTab;
  onChange: (next: CategoryTab) => void;
}

export function CategoriesTabs({ active, onChange }: CategoriesTabsProps) {
  const { t } = useTranslation();
  return (
    <div className="-mx-1 overflow-x-auto px-1">
      <Tabs value={active} onValueChange={(v) => onChange(v as CategoryTab)}>
        <TabsList className="w-max">
          {CATEGORY_TABS.map((tab) => (
            <TabsTrigger key={tab} value={tab} className="capitalize">
              {t(`feature.categories.tabs.${tab}`)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
